import { render, staticRenderFns } from "./AnnouncementBanner.vue?vue&type=template&id=5ccc1103&scoped=true&name=announcement-baner&"
import script from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementBanner.vue?vue&type=style&index=0&id=5ccc1103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc1103",
  null
  
)

export default component.exports